<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col class="m-lg-5 mt-xs-3 p-0">
          <div class="flex-head mb-5">
            <h2 class="font-weigth-bold">Your Subscriptions</h2>
            <b-button
              class="prompt-button p-2"
              :to="{ name: 'upgrade' }"
              variant="success"
              >Add Another plan</b-button
            >
          </div>

          <b-skeleton-wrapper
            class="text-center"
            :loading="loading"
          >
            <template #loading>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
            </template>

            <b-card v-if="!loading">
              <h1 class="ml-lg-4 mb-3">Current Active Plans</h1>
              <div class="p-3" v-if="premiumplans.length > 0">
                <!-- {{ premiumplans }} -->
                <div
                  class="p-4 plan-box"
                  v-for="(plans, index) in premiumplans"
                  :key="index"
                >
                  <!-- {{ plans }} -->
                  <!-- <h2>Plan {{ index + 1 }}</h2> -->
                  <h3>Plan Details</h3>
                  <div class="pl-3">
                    <b-row>
                      <b-col xs="6">
                        <p class="upgrade-details">Name :</p>
                      </b-col>

                      <b-col xs="6">
                        <p class="upgrade-details-value">
                          {{ plans.user_name }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col xs="6">
                        <p class="upgrade-details">Email :</p>
                      </b-col>

                      <b-col xs="6">
                        <p class="upgrade-details-value">
                          {{ plans.user_email }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row v-if="plans?.premium_category == 'Individual'">
                      <b-col xs="6">
                        <p class="upgrade-details">Category :</p>
                      </b-col>

                      <b-col xs="6">
                        <p class="upgrade-details-value">
                          {{ plans.category }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row v-if="plans?.premium_category == 'Organization'">
                      <b-col xs="6">
                        <p class="upgrade-details">Credits Remaining :</p>
                      </b-col>

                      <b-col xs="6">
                        <p class="upgrade-details-value">
                          {{ plans.test_credits }} Credits
                        </p>
                      </b-col>
                    </b-row>

                    <b-row v-if="plans?.premium_category == 'Individual'">
                      <b-col xs="6">
                        <p class="upgrade-details">Institution :</p>
                      </b-col>

                      <b-col xs="6">
                        <p class="upgrade-details-value">
                          {{ plans.institution }}
                        </p>
                      </b-col>
                    </b-row>

                    <div v-if="premiumplans.length > 0">
                      <b-row v-if="plans.level.length > 0">
                        <b-col xs="6">
                          <p class="upgrade-details">Level :</p>
                        </b-col>

                        <b-col xs="6">
                          <p class="upgrade-details-value">{{ plans.level }}</p>
                        </b-col>
                      </b-row>
                    </div>
                  </div>

                  <h3>Subscription Details</h3>
                  <div class="pl-3">
                    <b-row>
                      <b-col xs="6">
                        <p class="upgrade-details">Plan Type :</p>
                      </b-col>

                      <b-col xs="6">
                        <p class="upgrade-details-value">
                          {{ plans.premium_type }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col xs="6">
                        <p class="upgrade-details">Plan Variant :</p>
                      </b-col>

                      <b-col xs="6">
                        <p class="upgrade-details-value">
                          {{ plans.premium_variant }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col xs="6">
                        <p class="upgrade-details">Plan Duration :</p>
                      </b-col>

                      <b-col xs="6">
                        <p class="upgrade-details-value">
                          {{ plans.premium_duration }}
                          {{
                            plans.premium_type == "Annually" ? "Year" : "Month"
                          }}{{ plans.premium_duration > 1 ? "s" : "" }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col xs="6">
                        <p class="upgrade-details">Amount Paid :</p>
                      </b-col>

                      <b-col xs="6">
                        <p class="upgrade-details-value">
                          N{{ plans.amount_paid }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col xs="6">
                        <p class="upgrade-details">Payment was made on :</p>
                      </b-col>

                      <b-col xs="6">
                        <p class="upgrade-details-value">
                          {{ plans.payment_date }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col xs="6">
                        <p class="upgrade-details">Plan will expire on:</p>
                      </b-col>

                      <b-col xs="6">
                        <p class="upgrade-details-value">
                          {{ plans.expiry_date }}
                        </p>
                      </b-col>
                    </b-row>
                  </div>

                  <h3>Plan Renewal</h3>

                  <div class="pl-3">
                    <b-row>
                      <b-col xs="6">
                        <p class="upgrade-details">Auto Renew Plan :</p>
                      </b-col>

                      <b-col xs="6">
                        <p
                          class="upgrade-details-value"
                          v-if="plans.save_card == 'Yes'"
                        >
                          <b-form-checkbox
                            @input="offRenew(plans.track_id)"
                            :checked="true"
                            switch
                            size="lg"
                          ></b-form-checkbox>
                        </p>
                        <p
                          class="upgrade-details-value"
                          v-if="plans.save_card == 'No'"
                        >
                          <b-form-checkbox
                            @input="onRenew(plans.track_id)"
                            :checked="false"
                            switch
                            size="lg"
                          ></b-form-checkbox>
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col xs="6">
                        <p class="upgrade-details">Card Details :</p>
                      </b-col>

                      <b-col
                        xs="6"
                        v-if="
                          plans.channel == 'card' && plans.save_card == 'Yes'
                        "
                      >
                        <p>
                          <b>Account Name :</b>
                          {{ plans.authorization.account_name }}
                        </p>
                        <p>
                          <b>Account Name :</b> {{ plans.authorization.bank }}
                        </p>
                        <p>
                          <b>Card type :</b>
                          {{
                            plans.authorization.brand.charAt(0).toUpperCase() +
                              plans.authorization.brand.slice(1)
                          }}
                        </p>
                        <p>
                          <b>Expiring date :</b>
                          {{ plans.authorization.exp_month }}/{{
                            plans.authorization.exp_year
                          }}
                        </p>
                        <p>
                          <b>First 6 digits :</b> {{ plans.authorization.bin }}
                        </p>
                        <p>
                          <b>Last 4 digits :</b> {{ plans.authorization.last4 }}
                        </p>
                      </b-col>

                      <b-col xs="6" v-else>
                        Card wasn't used or has been deactivated for auto
                        renewal
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
              <h3 v-else>
                You do not have any active Subscription.
                <b-link :to="{ name: 'upgrade' }">Upgrade Now</b-link> to
                practice Unlimitedly!
              </h3>
            </b-card>
          </b-skeleton-wrapper>
          <b-skeleton-wrapper
            class="text-center"
            :loading="loading"
          >
            <template #loading>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
            </template>
          </b-skeleton-wrapper>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import store from "@/store";

export default {
  async mounted() {
    await this.fetchData();

    //Update the User Object with initial values from the Details on last logged in.

    this.profileimagelink = this.$store.state.loginmaster.details.profileimage;
    // Grab the Institutions names from the institution object and update the institution array of the Data Property
    let inst = this.allinsti.map(x => x.name);
    this.instiarr = inst;
  },

  data() {
    return {
      saving: false,
      instiarr: [],
      profileimagelink: "",
      uploadingprofileimage: false,
      discarding: false,
      showcopy: false,
      plans: {
        level: ""
      },
      loading : false
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   store.dispatch("dashboard/fetchPremiumplans");
  //   next();
  // },

  methods: {
    ...mapActions("dashboard", ["fetchPremiumplans", "setRenew", "unsetRenew"]),
    ...mapActions("loginmaster", ["updateDetails"]),

    async fetchData() {
      this.loading = true;
      try {
        await this.fetchPremiumplans();
        this.loading = false;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    // Get the Contents of the Submitted form in an Object

    onRenew(trackid) {
      this.$bvModal
        .msgBoxConfirm(
          "Put on Auto Renew. We would help you Renew when its time.",
          {
            title: "Activate Auto Renewal",
            okVariant: "danger",
            okTitle: "Yes, Activate",
            cancelTitle: "No, Don't Activate",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(() => {
          return this.setRenew(trackid).then(() => {
            this.fetchPremiumplans();
          });
        })
        .catch(() => {});
    },
    offRenew(trackid) {
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to Off Auto Renew. We can't help you Renew if you proceed.",
          {
            title: "Please Confirm",
            okVariant: "danger",
            okTitle: "Yes, stop auto renewal",
            cancelTitle: "No, continue auto renewing",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(() => {
          return this.unsetRenew(trackid).then(() => {
            this.fetchPremiumplans();
          });
        })
        .catch(() => {});
    },

    saveProfile() {
      this.saving = true; // Update the saving status to true. This triggers on the roller overlay over the button and disables the button.

      // Call the saveUserProfile from the Store's action and pass the user object to it
      return this.saveUserProfile(this.user).then(() => {
        // After the request has been made and a response received. change the saving status to false to release the button and trigger off the roller.
        this.saving = false;
        this.updateDetails();

        // Send a Modal alert telling the User that the Profile has been saved Successfully.
        this.$bvModal
          .msgBoxOk("Your Profile has been updated Successfully.", {
            title: "Profile Updated",
            size: "xs",
            centered: true
          })
          .then(() => {});
      });
    },
    copylink() {
      navigator.clipboard.writeText(
        `${this.origin}/signup/?ref=${this.$store.state.loginmaster.details.refcode}`
      );
      this.showcopy = true;
    }
  },
  computed: {
    ...mapState({
      userdet: state => state.loginmaster.details,
      plan: state => state.loginmaster.details.plan,
      premium: state => state.loginmaster.details.premium_details,
      allinsti: state => state.admin.listinstitutions,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.site_origin,
      premiumplans: state => state.dashboard.premiumplans,
      fetchingpp: state => state.dashboard.fetchingpp
    })
  }
};
</script>

<style scoped>
.fo-pro {
  width: 75%;
  margin-left: 1.5rem;
}

.secll {
  font-weight: bold;
  font-size: 1.1rem;
}

.profile-wrap {
  display: flex;
  flex-wrap: wrap;
}
.text-profile {
  width: 60%;
}
.picture-profile {
  width: 40%;
}

.plan-box{
  background: ghostwhite;
  border-radius: 10px 10px;
  border: 1px solid black;
  margin-top:20px;
}

.profile-image {
  width: 300px;
  height: 300px;
  display: inline-block;
  border-radius: 10px 10px;
}
.profile-photo-input {
  font-size: 2rem;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  border: 0px;
  border-radius: 0px;
  height: 10rem;
  display: none;
}

.v-button {
  border-radius: 10px 10px;
  height: 3rem;
  background-color: white;
  font-weight: bolder;
  color: black;
  position: relative;
  bottom: -80%;
  border: 1px solid #00984a;
  font-size: 18px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}

.v-button2 {
  border-radius: 10px 10px;
  height: 3rem;
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 18px;
}
.v-button2:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}
.flex-head {
  display: flex;
  justify-content: space-between;
}
.copyinline {
  background-color: #000000;
  color: white;
  display: inline-flex;
  overflow: auto;
  scrollbar-width: thin;
  border-radius: 10px 10px;
}

.copyicon {
  width: 10%;
  cursor: pointer;
  left: -100px;
}

.copytext {
  width: 90%;
  overflow: auto;
  scrollbar-width: thin;
}

.copier {
  position: absolute;
  left: -9999px;
}
.copied {
  position: relative;
  left: -10px;
  font-size: 0.7rem;
}
.upgrade-details {
  font-size: 1.2rem;
  font-weight: bold;
}

.upgrade-details-value {
  font-size: 1.2rem;
}

@media screen and (max-width: 999px) {
  .fo-pro {
    width: 100%;
    margin-left: 0px;
  }
  .picture-profile {
    width: 100%;
  }
  .text-profile {
    width: 100%;
  }
  .v-button {
    font-size: 0.8rem;
  }
  .v-button2 {
    font-size: 0.8rem;
  }
  .upgrade-details {
    font-size: 0.85rem;
  }
  .upgrade-details-value {
    font-size: 0.85rem;
  }
}
</style>
